<!--
  组件设计（这个组件看似简单，其实异常复杂）
  1. 最开始的想法很简单，就是设计一个 Iconfont 的按钮，点击 Actvied，然后再点击 Deactived，然后辅以一些动效即可。
  2. 当遇到了 Tab/TabItems 组件后，事情稍微复杂了起来，点击 Actvied 后，再次点击不允许 Deactived，而是必须点击其他的 TabItem 才能 Deactive
     当前的 Iconfont。于是乎新的属性 allowDeactive 和其他相关的方法便应运而生！
     TODO，现在想想，其实这种 mixin 的设计非常的不好，是否能够在原有的 Iconfont 之上再单独封装一个 DeactiveIconfont 来解耦这个逻辑？
  3. 这个应该是我使用 Props 以来一直的一个疑问，官网有关 Prop 的单向数据流（https://cn.vuejs.org/v2/guide/components-props.html#%E5%8D%95%E5%90%91%E6%95%B0%E6%8D%AE%E6%B5%81）
     里面明确的约束了，Prop 的改动只能是从父组件 -> 子组件，反之即子组件 -> 父组件是不能的，也就是说子组件不能去修改父组件传递给子组件的 Prop 值。
     这就造成了一个非常大的困境，子组件往往是需要修改这个值来更新自己的状态的！而 Vue 官网建议是，在 data 中单独定义一个属性，将 prop 属性的值
     初始化赋值给该 data 属性，这样子组件就可以使用自己的 data 属性来响应了，就不违背这个原则了。但是，父组件传递的 Prop 属性也就失去了对子组件
     的动态响应的控制！相当于解决了子组件问题的同时，引入了父组件的问题。我的解决办法是引入 watch，监听 prop 属性，一旦发生变化，将新的值赋值给
     子组件的 data 属性，以实现父组件通过 prop 属性动态更新子组件的需要！这也就是为什么使用 watch 的原因！
-->
<template>
    <!-- 注意：iconfont 一定不要使用 i 标签，不然 "iconfont icon-sy-emoji1" 等这样的样式图标缩放（transform）会失效！-->
    <!-- 天啦撸，我怎么会写出这么丑陋的代码，这个 v-if else 主要是避免在 H5 上使用 mounseenter 和 mouseout 事件，避免 IOS H5 hover
         的问题。TODO 想到更好的解决方案，避免代码重复 -->
    <div :class="{'iconfont-selector-hover': zoomable}" v-if="!isMobileAgent"
         class="iconfont-selector"
         :style="styleObject"
         style="display: inline-flex; align-items: center; justify-content: center; cursor: pointer;"
         @mouseenter="color_ = activedColor"
         @mouseleave="color_ = actived ? activedColor : defaultColor"
         @click="click_">
        <!-- the iconfont -->
        <div :class="actived ? activedClass : defaultClass"
             :style="{ 'font-size': fontSize+'px', 'line-height': lineHeight+'px', 'color': color_ , 'font-weight': fontWeight }">
        </div>
        <!-- the text -->
        <div v-if="text!=null"
             :style="{ 'font-size': textFontSize+'px', 'line-height': lineHeight+'px', 'color': color_, 'font-weight': textFontWeight, 'padding-left': textPaddingLeft + 'px' }"
        >{{text}}</div>
    </div>
    <div :class="{'iconfont-selector-hover': zoomable}" v-else
         class="iconfont-selector"
         :style="styleObject"
         style="display: inline-flex; align-items: center; justify-content: center; cursor: pointer;"
         @click="click_">
        <!-- the iconfont -->
        <div :class="actived ? activedClass : defaultClass"
             :style="{ 'font-size': fontSize+'px', 'line-height': lineHeight+'px', 'color': color_ , 'font-weight': fontWeight }">
        </div>
        <!-- the text -->
        <div v-if="text!=null"
             :style="{ 'font-size': textFontSize+'px', 'line-height': lineHeight+'px', 'color': color_, 'font-weight': textFontWeight, 'padding-left': textPaddingLeft + 'px' }"
        >{{text}}</div>
    </div>
</template>

<script>
    import {isMobileAgent} from "../../utils";

    export default {
        name: "IconfontSelector",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            isActived: {
                type: Boolean,
                default: false
            },
            // 有些场景，比如 Channel Tab 控件要求一旦 iconfont selector 被激活，就不允许再通过点击将其置为初始状态了，而是要通过其它的
            // Channel Tab Items 的点击事件（激活）将当前的 Tab Item 给置为初始状态（即是将它内部的 iconfont selector 置为 default）
            allowDeactive: {
                type: Boolean,
                default: true
            },
            // 是否允许当鼠标 hover 发生后，产生放大效果！
            zoomable: {
                type: Boolean,
                default: true
            },
            /* 用户的回调方法 */
            handler: {
                type: Function,
                default: () => {}
            },
            styleObject: {
                type: Object
            },
            defaultColor: {
                type: String,
                default: '#2c3e50'
            },
            defaultClass: {
                type: String,
                default: 'el-icon-star-off'
            },
            activedColor: {
                type: String,
                default: '#E6A23C'
            },
            activedClass: {
                type: String,
                default: 'el-icon-star-on'
            },
            /* the iconfont size */
            fontSize: {
                type: Number,
                default: 30
            },
            /* the iconfont weight */
            fontWeight: {
                type: Number,
                defautl: 400
            },
            text: {
                type: String,
                default: null
            },
            /* the text font size */
            textFontSize: {
                type: Number,
                default: 14
            },
            /* the text font weight */
            textFontWeight: {
                type: Number,
                default: 400
            },
            textPaddingLeft: {
                type: Number,
                default: 6
            },
            lineHeight: {
                type: Number,
                default: 35
            }
        },
        data() {
            return {
                color_: this.isActived ? this.activedColor : this.defaultColor,
                actived_: this.isActived
            }
        },
        computed: {
            actived: {
                set: function(actived){
                    this.actived_ = actived;
                    this.actived_ ? this.color_ = this.activedColor : this.color_ = this.defaultColor;
                },
                get: function(){
                    return this.actived_
                }
            },
            isMobileAgent: function(){
                return isMobileAgent();
            }
        },
        // 为什么给 isActived prop 属性添加 watch 事件？参考该组件注解中的 #3。
        watch: {
            isActived: function(newVal, oldVal){
                if(this.disabled) return;
                console.log(`watch isActived ${oldVal}, ${newVal}`);
                this.actived = newVal;
            }
        },
        mounted(){
            // 在组件创建好以后，也同样需要告诉父组件我的状态如何，以便父组件根据状态进行调整，典型的例子便是 InconfontSelectorToolTips
            // 才可以根据 IconfontSelector 的内部 actived 的状态来设置 tooltips 该如何显示。
            this.$emit('init', this.actived);
        },
        methods: {
            click_(){
                if(this.disabled) return;
                this.handler(); // callback the user function
                var __actived = this.actived; // cache the old actived status.
                if(this.actived){
                    if(this.allowDeactive){
                        this.actived = false;
                    }
                }else{
                    this.actived = true;
                }
                // 只有当 actived 发生了改变，才发出 active 事件，
                __actived !== this.actived ? this.$emit('change', this.actived) : "";
            },
            deactive(){
                console.log('icon selector deactive() called');
                this.actived = false;
            },
            /**
             * 反转 actived 状态。提供这个方法主要是给 Entity Favorite 组件所使用，当用户没有登录，点击了 IconfontSelector 比如点赞按钮，
             * 结果检查，用户没有登录，因此需要把当前的选中状态反转。当然，从选中 -> 未选中的逻辑是一样的！
             */
            revert(){
                this.actived ? this.actived = false : this.actived = true;
            }
        }
    }
</script>

<style scoped>
    /* 将 hover 事件绑定到 class 上的目的是，可以通过取消绑定 class 以达到取消 hover 放大效果的目的 */
    /* IOS 上不能有 hover 时间，否则 click 事件要点击两次才会生效，这里将移动端都移除 hover 事件 */
    @media (min-width: 736px) {
        .iconfont-selector-hover:hover {
            /* TODO, set parameter to handle the scale */
            transform: scale(1.1);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/IconfontSelector.vue